import React, { FunctionComponent } from 'react'

import { CeeContentCreate } from '../components/CeeContentCreate/CeeContentCreate'
import { PageLayout } from '../components/PageLayout/PageLayout'

export const CeeMonitorCreate: FunctionComponent = () => {
  return (
    <PageLayout
      title="Přidat subjekt do periodického hlídání v CEE"
      isContainer
    >
      <CeeContentCreate isMonitoring />
    </PageLayout>
  )
}

export default CeeMonitorCreate
